module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"52px\" height=\"52px\" viewBox=\"0 0 52 52\" enable-background=\"new 0 0 52 52\" xml:space=\"preserve\"><g><g opacity=\"0.8\"><path fill=\"#DADADA\" d=\"M26,4c12.1,0,22,9.9,22,22s-9.9,22-22,22S4,38.1,4,26S13.9,4,26,4 M26,0C11.6,0,0,11.6,0,26s11.6,26,26,26 s26-11.6,26-26S40.4,0,26,0L26,0z\"></path></g><g><path fill=\"#EB710B\" d=\"M26,0v4c12.1,0,22,9.9,22,22s-9.9,22-22,22v4c14.4,0,26-11.6,26-26S40.4,0,26,0z\"></path></g></g></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/loader.svg
 ** module id = 1051
 ** module chunks = 0
 **/